import fetch from "cross-fetch"

import { getDefaultHeaders, handleErrors } from "core/api"
import endpoints from "core/endpoints"

class QuotationsAPI {
  fetchList() {
    return handleErrors(
      fetch(endpoints.quotationsList(), {
        method: "get",
        headers: getDefaultHeaders(),
      })
    )
  }
}

export default new QuotationsAPI()
